import React, { useState } from 'react'
import MappingSelect from '../../Shared/Components/MappingSelect'
import Shared from '../../Shared/mappingUi.module.css'
import Style from '../salesPersonMapping.module.css'

const EMPTY_DRAFT = {
    erpSalesPersonCode: '',
    erpSalesPersonId: '',
    ecommerceSalesPersonCode: '',
    ecommerceSalesPersonId: ''
}

/**
 * The "add a mapping" row. Owns only its own draft; a completed pair is handed to
 * the parent through onAdd and the draft resets.
 */
const MappingForm = ({ erpSalesPersons, ecommerceSalesPersons, isDisabled, isDuplicate, onAdd }) => {
    const [draft, setDraft] = useState(EMPTY_DRAFT)
    const [error, setError] = useState('')
    // Bumped after every add so both pickers remount and drop any custom-entry mode.
    const [formKey, setFormKey] = useState(0)

    const change = (changes) => {
        setDraft((current) => ({ ...current, ...changes }))
        setError('')
    }

    const handleAdd = () => {
        if (draft.erpSalesPersonCode === '' && draft.ecommerceSalesPersonCode === '') {
            setError('Select an ERP and an eCommerce sales person to map.')
            return
        }
        if (draft.erpSalesPersonCode === '') {
            setError('Select an ERP sales person.')
            return
        }
        if (draft.ecommerceSalesPersonCode === '') {
            setError('Select an eCommerce sales person.')
            return
        }
        if (isDuplicate(draft.erpSalesPersonCode)) {
            setError(`"${draft.erpSalesPersonCode}" is already mapped. Edit the existing row instead.`)
            return
        }

        onAdd(draft)
        setDraft(EMPTY_DRAFT)
        setError('')
        setFormKey((current) => current + 1)
    }

    return (
        <div className={Shared.formPanel}>
            <div className={`${Shared.grid} ${Style.grid}`}>
                <label className={Shared.fieldLabel} htmlFor="erpSalesPersonSelect">ERP Sales Person</label>
                <span />
                <label className={Shared.fieldLabel} htmlFor="ecommerceSalesPersonSelect">eCommerce Sales Person</label>
                <span />

                <MappingSelect
                    key={`erp-${formKey}`}
                    inputId="erpSalesPersonSelect"
                    options={erpSalesPersons}
                    value={draft.erpSalesPersonCode}
                    placeholder="Select ERP Sales Person"
                    customLabel="Custom ERP Sales Person"
                    customPlaceholder="Enter ERP sales person code"
                    hasError={error !== '' && draft.erpSalesPersonCode === ''}
                    isDisabled={isDisabled}
                    onChange={(value, option) => change({
                        erpSalesPersonCode: value,
                        erpSalesPersonId: option ? option.id : ''
                    })}
                />
                <span className={Shared.arrow} aria-hidden="true">&rarr;</span>
                <MappingSelect
                    key={`ecommerce-${formKey}`}
                    inputId="ecommerceSalesPersonSelect"
                    options={ecommerceSalesPersons}
                    value={draft.ecommerceSalesPersonCode}
                    placeholder="Select eCommerce Sales Person"
                    customLabel="Custom eCommerce Sales Person"
                    customPlaceholder="Enter eCommerce sales person code"
                    hasError={error !== '' && draft.ecommerceSalesPersonCode === ''}
                    isDisabled={isDisabled}
                    onChange={(value, option) => change({
                        ecommerceSalesPersonCode: value,
                        ecommerceSalesPersonId: option ? option.id : ''
                    })}
                />
                <button
                    type="button"
                    className={Shared.addButton}
                    title="Add mapping"
                    aria-label="Add mapping"
                    disabled={isDisabled}
                    onClick={handleAdd}
                >
                    <i className="uil-plus" aria-hidden="true" />
                </button>
            </div>
            {error ? <p className={Shared.formError} role="alert">{error}</p> : null}
        </div>
    )
}

export default MappingForm
